// components/LoadingScreen.jsx
import { useEffect, useState } from 'react';
import './LoadingScreen.css';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const LoadingScreen = ({ splineReady = false }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [animationReady, setAnimationReady] = useState(false);

  useEffect(() => {
    // Only hide loading screen when both page and splines are loaded
    const handleLoad = () => {
      if (splineReady && animationReady) {
        setTimeout(() => {
          setIsLoading(false);
        }, 3000);
      }
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
      
      const timeoutId = setTimeout(() => {
        handleLoad();
      }, 3000);

      return () => {
        window.removeEventListener('load', handleLoad);
        clearTimeout(timeoutId);
      };
    }
  }, [splineReady, animationReady]);

  useEffect(() => {
    if (splineReady && animationReady) {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  }, [splineReady, animationReady]);

  if (!isLoading) return null;

  return (
    <div className="loading-screen flex items-center justify-center">
      {!animationReady && (
        <div className="absolute">
          <div className="w-20 h-20 border-4 border-gray-300 dark:border-gray-600"></div>
          <div className="absolute top-0 left-0 w-20 h-20 border-4 border-transparent border-t-[#43d9ad] animate-spin"></div>
          <div className="absolute top-0 left-0 w-20 h-20 border-4 border-transparent border-r-[#F9FD03] animate-spin" style={{ animationDirection: 'reverse', animationDuration: '1.5s' }}></div>
        </div>
      )}
      <DotLottieReact
        src="https://lottie.host/03586e02-ee45-4ddf-b086-a59302d8c500/Xv7lDq6cXk.json"
        loop
        autoplay
        style={{
          width: '250px',
          height: '250px',
          opacity: animationReady ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out'
        }}
        dotLottieRefCallback={(dotLottie) => {
          dotLottie.addEventListener('load', () => {
            setAnimationReady(true);
          });
        }}
      />
    </div>
  );
};

export default LoadingScreen;